import * as types from '../actions/actionTypes';

const initialState = {
    showSidebar: true,
    savedSearchList: {
        loading: false,
        success: true,
        data: [],
        deleting: {}
    },
    savedSearch: {
        loading: false,
        success: true,
        data: {}
    },
    newSearch: {
        loading: false,
        success: true
    },
    filters: {
        keyword: '',
        recipientSearch: '',
        recipients: [],
        reportName: '',
        reportMemo: '',
        firstName: '',
        lastName: '',
        teudatZahut: '',
        phoneNumber: '',
        checkNumber: '',
        categories: [],
        nationalities: [],
        recipientTypes: [],
        recipientStatuses: [],
        applicationStatuses: [],
        applicationReasons: [],
        approvers: [],
        references: [],
        sources: [],
        funds: [],
        campaigns: [],
        campaignIndividualCategories: [],
        campaignLists: [],
        organizations: [],
        taxId: '',
        streetNum: '',
        streetNames: [],
        cities: [],
        startDate: '',
        endDate: '',
        bankAccount: '',
        hasPledges: false,
        incomplete: false,
        hasAchAccount: false,
        hasReceipt: null
    },
    appliedFilters: {
        keyword: '',
        reportName: '',
        reportMemo: '',
        firstName: '',
        lastName: '',
        teudatZahut: '',
        phoneNumber: '',
        checkNumber: '',
        categories: [],
        nationalities: [],
        recipientTypes: [],
        recipientStatuses: [],
        applicationStatuses: [],
        applicationReasons: [],
        approvers: [],
        references: [],
        sources: [],
        funds: [],
        campaigns: [],
        campaignIndividualCategories: [],
        campaignLists: [],
        organizations: [],
        taxId: '',
        streetNum: '',
        streetNames: [],
        cities: [],
        startDate: '',
        endDate: '',
        bankAccount: '',
        hasPledges: false,
        incomplete: false,
        hasAchAccount: false,
        hasReceipt: null
    }
}

export default filterType => {
    return (state = initialState, action) => {
        switch (action.type) {
            case types[`TOGGLE_${filterType}_SIDEBAR_FILTERS`]:
                return Object.assign({}, state, { showSidebar: !state.showSidebar });
            case types[`UPDATE_${filterType}_SIDEBAR_FILTERS`]:
                return Object.assign({}, state, { 
                    filters: { ...state.filters, ...action.update },
                    savedSearch: initialState.savedSearch
                 });
            case types[`RESET_${filterType}_SIDEBAR_FILTERS`]:
                return Object.assign({}, state, { 
                    filters: initialState.filters,
                    appliedFilters: action.applyFilters ? initialState.filters : state.appliedFilters,
                    savedSearch: initialState.savedSearch
                });
            case types[`SET_${filterType}_APPLIED_FILTERS`]:
                return Object.assign({}, state, { appliedFilters: action.filters });

            case types[`START_GET_${filterType}_SAVED_SEARCHES`]:
                return Object.assign({}, state, {
                    savedSearchList: { ...initialState.savedSearchList, loading: true }
                });
            case types[`GET_${filterType}_SAVED_SEARCHES`]:
                return Object.assign({}, state, {
                    savedSearchList: { ...initialState.savedSearchList, ...action.response }
                });
            case types[`START_GET_${filterType}_SAVED_SEARCH`]:
                return Object.assign({}, state, {
                    savedSearch: { ...state.savedSearch, loading: true }
                });
            case types[`GET_${filterType}_SAVED_SEARCH`]:
                let { savedSearchId, name, fields } = action.response.data;
                return Object.assign({}, state, {
                    savedSearch: { ...action.response, data: { key: savedSearchId, value: name } },
                    filters: { ...state.filter, ...fields }
                });
            case types[`START_CREATE_${filterType}_SAVED_SEARCH`]:
                return Object.assign({}, state, {
                    newSearch: { ...state.newSearch, loading: true }
                });
            case types[`CREATE_${filterType}_SAVED_SEARCH`]:
                return Object.assign({}, state, {
                    savedSearchList: action.response.success ? { ...state.savedSearchList, data: [...state.savedSearchList.data, action.response.data] } : state.savedSearchList,
                    savedSearch: action.response.success ? { ...state.savedSearch, data: action.response.data } : state.savedSearch,
                    newSearch: { loading: false, success: action.response.success }
                });
            case types[`START_DELETE_${filterType}_SAVED_SEARCH`]:
                return Object.assign({}, state, {
                    savedSearchList: {
                        ...state.savedSearchList,
                        deleting: { ...state.savedSearchList.deleting, ...{ [action.savedSearchId]: true } }
                    }
                });
            case types[`DELETE_${filterType}_SAVED_SEARCH`]:
                let deletingSearches = { ...state.savedSearchList.deleting };
                action.response.success
                    ? delete deletingSearches[action.response.savedSearchId]
                    : deletingSearches[action.response.savedSearchId] = false;
                return Object.assign({}, state, {
                    savedSearch: action.response.success ? initialState.savedSearch : state.savedSearch,
                    savedSearchList: {
                        ...state.savedSearchList,
                        data: action.response.success ? state.savedSearchList.data.filter(s => s.key !== action.response.savedSearchId) : state.savedSearchList.data,
                        deleting: deletingSearches
                    }
                });
            default:
                return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/SidebarFiltersReducer.js